import { Tooltip as AntdTooltip } from "antd";

export const Tooltip = AntdTooltip;
